import { createRecordAction } from '../../utils';

export const fazDelNotificationAction = {
  ...createRecordAction('faz-del-notification'),
};
